import { useAtomValue } from 'jotai';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';

/**
 * Whether the Article suggestions section is available — its nav entry and its
 * route.
 *
 * Shares the multi-conversation draft flag with the AI-provenance UI (see
 * `useShowAiProvenance`): that flow is what fills the review queue, so with the
 * flag off the section would only ever be empty.
 */
export function useShowArticleSuggestions(): boolean {
  const { featureFlags } = useAtomValue(featureFlagsAtom);

  return featureFlags.smartArticleCreateMultiConversation;
}
